<!-- 公共的文件选择  视频,图片 -->
<template>
  <div class="PublicFileSelect">
    <!-- 视频选择 -->
    <div class="SelectVideo">
      <el-select
        v-model="pitchOnFile"
        :disabled="disabled"
        :popper-append-to-body="AppendBody"
        v-scroll="bindScroll"
        popper-class="file-search-select"
        filterable
        :filter-method="searchFile"
        @change="fileSelectChange">
        <el-option
          v-for="item in FileSelectList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          :title="item.name">
        </el-option>
      </el-select>
    </div>
    <!-- 图片选择 -->
    <div class="FileSelect"></div>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    //   选择的类型  1是视频选择类型  2是图片选择类型
    SelectType: {
      type: Number,
      default: 1
    },
    //   选择的参数
    SelectValue: {
      type: Object,
      default: () => ({
        fileId: '',
        fileName: ''
      })
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否将弹出框插入至 body 元素,在弹出框的定位出现问题时，可将该属性设置为 false
    AppendBody: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 文件选择列表
      FileSelectList: [],
      //   选中的文件id
      pitchOnFile: '',
      // 文件选择滚动
      bindScroll: {
        onScroll: this.getFileList,
        directive: '.el-select-dropdown__list',
        distance: 50
      },
      // 文件分页查询
      fileObj: {
        pageNum: 0,
        pageSize: 10,
        totalNum: 1,
        condition: ''
      }
    }
  },
  created () { },
  mounted () {
    this.FileEcho()
    this.getFileList()
  },
  watch: {
    // 监听外部传的值是否变化
    SelectValue (item) {
      this.FileEcho()
      // this.pitchOnFile = item.fileId;
    }
  },
  methods: {
    // 获取文件列表
    getFileList () {
      // if (this.fileObj.pageNum >= this.fileObj.totalNum) return
      // this.fileObj.pageNum++
      // this.axios.post('/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/pageMedia', this.fileObj, {
      //   contentType: 'application/json;charset=UTF-8'
      // }
      // ).then((res) => {
      //   if (res.data.errorCode == '0x0') {
      //     //   拿第一页时存总页数
      //     if (this.fileObj.pageNum == 1) {
      //       this.fileObj.totalNum = res.data.result.pages ? res.data.result.pages : 1
      //     }
      //     if (this.fileObj.pageNum > 1) {
      //       this.FileSelectList.push(...res.data.result.list)
      //     } else {
      //       this.FileSelectList = res.data.result.list
      //     }
      //   } else {
      //     const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
      //     this.$message.info(errorInfo)
      //   }
      // }).catch()
    },
    // 搜索文件列表
    searchFile (value) {
      this.fileObj.pageNum = 0
      this.fileObj.condition = value
      this.getFileList()
    },
    // 文件回显
    FileEcho (list) {
      if (this.SelectValue.fileName) {
        let inquire = false
        this.FileSelectList.forEach((item) => {
          if (item.id == this.SelectValue.fileId) inquire = true
        })
        this.pitchOnFile = inquire ? this.SelectValue.fileId : this.SelectValue.fileName
      } else {
        this.pitchOnFile = this.SelectValue.fileId
      }
    },
    // 文件选中变化
    fileSelectChange () {
      const FileMessage = this.FileSelectList.filter(
        (item) => item.id === this.pitchOnFile
      )
      this.fileObj.pageNum = 0
      this.fileObj.condition = ''
      this.getFileList()
      // console.log(FileMessage);
      this.$emit('fileSelectChange', FileMessage[0])
    }
  }
}
</script>
